// Hook for consuming the AuthContext.
// @ts-check
import { useContext } from 'react';
import { AuthContext } from '@/features/auth/AuthContext.def';

/**
 * Custom hook to consume the AuthContext.
 *
 * @returns {AuthContextValue} The current authentication state and user info.
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
